import React, { useState } from 'react'

import { globalClickHandler } from '@/helpers/globalClickHandler'
import { Body, Button, COLORS, Spacer, TitleLarge } from 'ethos-design-system'
import { cmsModuleAnalytics } from 'lib/@getethos/analytics/analyticsEvents'
import { EVENT_NAMES, MODULES } from 'lib/@getethos/analytics/constants'
import { transmitRiskToken } from 'lib/TransmitSecurity/riskToken'

import LeadFormModal from '@/components/EstimateWidget/FloatingVariation/FloatingForm/experiments/LeadForm/LeadFormModal'

import Markdown, { MARKDOWN_NODE_RESTRICTION_SETS } from '../global/Markdown'
import styles from './BannerText.module.scss'

const BannerText = ({ moduleData }: any) => {
  const [isLeadFormModalOpen, setIsLeadFormModalOpen] = useState(false)

  let utmSource: any = 'none'
  if (typeof window !== 'undefined') {
    const urlSearchParams = new URLSearchParams(window.location.search)
    if (urlSearchParams.has('utm_source')) {
      utmSource = urlSearchParams.get('utm_source')
    }
  }

  const Centered = moduleData.center
  const ShouldDisplayHeaders = moduleData.displayHeading
  let ShouldDisplaySubHeading = null
  if (!ShouldDisplayHeaders) {
    ShouldDisplaySubHeading = false
  } else {
    ShouldDisplaySubHeading = moduleData.displaySubHeading
  }
  const ShouldDisplayBlockCTA = moduleData.displayCta
  const CapitalizedBackgroundColor =
    moduleData.backgroundColor.charAt(0).toUpperCase() +
    moduleData.backgroundColor.slice(1)
  const BannerTextInnerClasses = [
    styles.BannerText__Inner,
    styles[`BannerText__Inner${CapitalizedBackgroundColor}`],
    Centered ? styles.BannerText__InnerColumn : null,
  ]
  const CtaLabel = (
    <>
      {moduleData.ctaLabel}
      <span>&#8594;</span>
    </>
  )
  const BannerWrapperClasses = [
    styles.BannerText__Wrapper,
    [Centered ? 'text-center' : null],
  ]

  let finalClickthrough: string = '#'
  if (!moduleData.showLeadFormModal) {
    finalClickthrough = moduleData.queryParams
      ? `${moduleData.clickthroughUrl}?${moduleData.queryParams}`
      : moduleData.clickthroughUrl
  }

  return (
    <div className={BannerWrapperClasses.join(' ')}>
      <LeadFormModal
        isLeadFormModalOpen={isLeadFormModalOpen}
        setIsLeadFormModalOpen={setIsLeadFormModalOpen}
      />
      <div className={BannerTextInnerClasses.join(' ')}>
        {ShouldDisplayHeaders && (
          <div className={styles.Module__Headings}>
            {Centered ? (
              <div className={styles.Heading}>
                <Markdown
                  input={moduleData.heading}
                  allowedMarkdownTypes={
                    MARKDOWN_NODE_RESTRICTION_SETS.LINK_ONLY
                  }
                />
              </div>
            ) : (
              <TitleLarge.Serif.Regular400>
                <Markdown
                  input={moduleData.heading}
                  allowedMarkdownTypes={
                    MARKDOWN_NODE_RESTRICTION_SETS.LINK_ONLY
                  }
                />
              </TitleLarge.Serif.Regular400>
            )}
            {ShouldDisplaySubHeading && (
              <>
                {Centered ? (
                  <div className={styles.SubHeading}>
                    <Markdown
                      input={moduleData.subHeading}
                      allowedMarkdownTypes={
                        MARKDOWN_NODE_RESTRICTION_SETS.LINK_ONLY
                      }
                    />
                  </div>
                ) : (
                  <>
                    <Spacer.H16 />
                    <Body.Regular400 color={COLORS.GRAY_PRIMARY}>
                      <Markdown
                        input={moduleData.subHeading}
                        allowedMarkdownTypes={
                          MARKDOWN_NODE_RESTRICTION_SETS.LINK_ONLY
                        }
                      />
                    </Body.Regular400>
                  </>
                )}
              </>
            )}
          </div>
        )}
        {ShouldDisplayBlockCTA && (
          <div className={styles.BannerText__CTA}>
            <a
              href={finalClickthrough}
              onClick={(event) => {
                moduleData.showLeadFormModal && setIsLeadFormModalOpen(true)
                if (moduleData.clickthroughUrl.includes('/app/')) {
                  transmitRiskToken()
                  const analyticsEvent = {
                    name: EVENT_NAMES.CTA_CLICKED,
                    properties: {
                      module: MODULES.BANNER,
                      ctaLabel: moduleData.ctaLabel,
                      clickthroughUrl: finalClickthrough,
                      utmSource: utmSource,
                    },
                  }
                  globalClickHandler({
                    event,
                    analyticsEvent,
                    urlProps: {
                      url: finalClickthrough,
                    },
                  })
                } else {
                  cmsModuleAnalytics.ctaClicked({
                    properties: {
                      module: MODULES.BANNER,
                      ctaLabel: moduleData.ctaLabel,
                      clickthroughUrl: finalClickthrough,
                      utmSource: utmSource,
                    },
                  })
                }
              }}
            >
              <div className={styles.PhoneAndTablet}>
                {CapitalizedBackgroundColor === 'Ocean' ? (
                  <Button.Medium.DarkSalamander>
                    {CtaLabel}
                  </Button.Medium.DarkSalamander>
                ) : (
                  <Button.Medium.BlackOutline>
                    {CtaLabel}
                  </Button.Medium.BlackOutline>
                )}
              </div>
              <div className={styles.LaptopAndUp}>
                {CapitalizedBackgroundColor === 'Ocean' ? (
                  <Button.Medium.DarkSalamander>
                    {CtaLabel}
                  </Button.Medium.DarkSalamander>
                ) : (
                  <Button.Medium.BlackOutline>
                    {CtaLabel}
                  </Button.Medium.BlackOutline>
                )}
              </div>
            </a>
          </div>
        )}
      </div>
    </div>
  )
}

BannerText.BACKGROUND_COLORS = {
  MOSS: 'moss',
  BUTTERCUP: 'buttercup',
  DUCKEGG: 'duckegg',
  WHITE: 'white',
  OCEAN: 'ocean',
}

export default BannerText
